import axios from "axios";
import { getCookie } from "./cookies";
import { env } from "./function";

axios.defaults.baseURL = env("SERVER");
// axios.defaults.withCredentials = true;

axios.interceptors.request.use(function (config) {
  const cleanToken = (token) => {
    if (!token || token === "undefined") return null;
    return token.replace(/^"|"$/g, "");
  };

  const accessToken = cleanToken(getCookie("clikkleStoreAccessToken"));
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  } else {
    const refreshToken = cleanToken(localStorage.getItem("refreshToken"));
    if (refreshToken) {
      config.headers.Authorization = `Bearer ${refreshToken}`;
    }
  }
  return config;
});
